import { axiosInstance } from '@/modules/shared/lib/axios'
import { BonusConfigurationModel } from '@/app/models/timesheet/bonusConfigurationModel'
import { BonusConfigurationQueryInput } from './types'

export function getBonusConfiguration({ companyId, payload }: BonusConfigurationQueryInput) {
  return axiosInstance.post<BonusConfigurationModel>(
    `/api/${companyId}/timesheet/bonusConfiguration`,
    payload,
  )
}
